export default __webpack_public_path__ + "static/media/java.464af996.png";